<!-- =========================================================================================
  File Name: AddNewDataSidebar.vue
  Description: Add New Data - Sidebar component
  ----------------------------------------------------------------------------------------
  Item Name: Galileo Computing VueJS Dashboard
  Author: Ian Kibet
  Author URL: http://ian.galileoc.co.ke
========================================================================================== -->

<template>
  <vs-sidebar
    click-not-close
    position-right
    parent="body"
    default-index="1"
    color="primary"
    class="add-new-data-sidebar items-no-padding"
    spacer
    v-model="isSidebarActiveLocal"
  >
    <div class="mt-6 flex items-center justify-between px-6">
      <h4>
        {{
          Object.entries(this.data).length === 0
            ? "ADD NEW"
            : this.showFarm
            ? "UPDATE"
            : "ADD NEW"
        }}
        EXPENSE
      </h4>
      <h6 v-if="!showFarm">
        {{ ef.a }}
      </h6>
      <feather-icon
        icon="XIcon"
        @click.stop="isSidebarActiveLocal = false"
        class="cursor-pointer"
      ></feather-icon>
    </div>
    <vs-progress
      v-show="farms.length != farms_encrypted.length"
      class="mb-0 mt-4"
      indeterminate
      color="primary"
    ></vs-progress>
    <vs-divider
      v-show="farms.length === farms_encrypted.length"
      class="mb-0"
    ></vs-divider>

    <VuePerfectScrollbar
      class="scroll-area--data-list-add-new"
      :settings="settings"
      :key="$vs.rtl"
    >
      <div class="p-6">
        <span v-if="showFarm" class="ml-1 mt-5 text-sm">Farm</span><br />
        <v-select
          v-show="showFarm"
          class="inputx w-full"
          v-model="ef"
          name="sub-category"
          label="a"
          :options="farms"
          :dir="$vs.rtl ? 'rtl' : 'ltr'"
          v-validate="'required'"
        />
        <span class="text-danger text-sm" v-show="errors.has('sub-category')">{{
          errors.first("sub-category")
        }}</span>
        <br /><span class="ml-1 mt-5 text-sm">Expense Type</span><br />
        <v-select
          class="inputx w-full"
          v-model="exc"
          name="expense-type"
          :options="excOp"
          :dir="$vs.rtl ? 'rtl' : 'ltr'"
          v-validate="'required'"
        />
        <span class="text-danger text-sm" v-show="errors.has('expense-type')">{{
          errors.first("expense-type")
        }}</span>

        <br /><span class="ml-1 mt-5 text-sm">Category</span><br />
        <v-select
          class="inputx w-full"
          v-model="et"
          name="category"
          :options="ect"
          :dir="$vs.rtl ? 'rtl' : 'ltr'"
          v-validate="'required'"
        />
        <span class="text-danger text-sm" v-show="errors.has('category')">{{
          errors.first("category")
        }}</span>

        <div v-if="ecet.length > 0">
          <br /><span class="ml-1 mt-5 text-sm">Sub Category</span><br />
          <v-select
            class="inputx w-full"
            v-model="etc"
            name="sub-category"
            label="b"
            :options="ecet"
            :dir="$vs.rtl ? 'rtl' : 'ltr'"
            v-validate="'required'"
          />
          <span
            class="text-danger text-sm"
            v-show="errors.has('sub-category')"
            >{{ errors.first("sub-category") }}</span
          >
        </div>

        <vs-input
          label="Total Amount Spent"
          v-model="amount"
          class="mt-5 w-full"
          name="amount"
          v-validate="'required|numeric'"
        />
        <span class="text-danger text-sm" v-show="errors.has('amount')">{{
          errors.first("amount")
        }}</span>

        <vs-textarea
          label="Description"
          class="w-full mt-5"
          v-validate="'required'"
          name="description"
          placeholder="Please describe this expense"
          rows="10"
          v-model="desc"
        />
        <span class="text-danger text-sm" v-show="errors.has('description')">{{
          errors.first("description")
        }}</span>
      </div>
    </VuePerfectScrollbar>

    <div class="flex flex-wrap items-center p-6" slot="footer">
      <vs-button class="mr-6" @click="submitData" :disabled="!isFormValid"
        >Submit</vs-button
      >
      <vs-button
        type="border"
        color="danger"
        @click="isSidebarActiveLocal = false"
        >Cancel</vs-button
      >
    </div>
  </vs-sidebar>
</template>

<script>
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import vSelect from "vue-select";

import p from "@/db/pouch";

export default {
  props: {
    isSidebarActive: {
      type: Boolean,
      required: true,
    },
    data: {
      type: Object,
      default: () => {},
    },
  },
  watch: {
    isSidebarActive(val) {
      if (!val) return;
      console.log(this.data);
      if (Object.entries(this.data).length === 0) {
        this.initValues();
        this.$validator.reset();
      } else if (Object.entries(this.data).length === 1) {
        this.initValues();
        this.$validator.reset();
        let { h } = JSON.parse(JSON.stringify(this.data));
        this.ef = h;
        this.showFarm = false;
      } else {
        let { _id, _rev, a, b, c, d, e, h } = JSON.parse(
          JSON.stringify(this.data)
        );
        this.id = _id;
        this.rev = _rev;
        this.amount = a;
        this.desc = b;
        this.et = c;
        this.etc = d;
        this.exc = e;
        this.ef = h;
        this.initValues();
      }
    },
    async etData(v) {
      this.expenseType = await p.de(v);
    },
    async farmData(v) {
      this.farms_encrypted = v;
      this.farms = await p.de(v);
    },
  },
  pouch: {
    etData() {
      return {
        database: process.env.VUE_APP_DB,
        selector: { z: 8 },
      };
    },
    farmData() {
      return {
        database: process.env.VUE_APP_DB,
        selector: { z: 6 },
      };
    },
  },
  data() {
    return {
      id: null,
      rev: null,
      showFarm: true,
      ef: "",
      amount: 0,
      desc: "",
      et: "",
      etc: "",
      exc: "",
      ec: [],
      ect: ["Purchase", "Bills", "Repairs", "Labour", "Misc."],
      excOp: ["Liability", "Asset"],
      expenseType: [],
      farms: [],
      farms_encrypted: [],
      settings: {
        maxScrollbarLength: 60,
        wheelSpeed: 0.6,
      },
    };
  },
  computed: {
    isSidebarActiveLocal: {
      get() {
        return this.isSidebarActive;
      },
      set(val) {
        if (!val) {
          this.$emit("closeSidebar");
          // this.$validator.reset()
          // this.initValues()
        }
      },
    },
    isFormValid() {
      return (
        !this.errors.any() &&
        this.amount &&
        this.amount > 0 &&
        this.desc &&
        this.et &&
        (this.ecet.length > 0 ? this.etc : this.et) &&
        this.exc &&
        this.ef
      );
    },
    ecet() {
      this.etc = "";
      return this.expenseType.filter((e) => e.a === this.et);
    },
  },

  methods: {
    initValues() {
      if (this.data._id) return;
      this.amount = 0;
      this.desc = "";
      this.et = "";
      this.etc = "";
      this.exc = "";
      this.exc = "";
      this.ec = [];
      this.ef = "";
    },
    submitData() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.$vs.notify({
            color: "warning",
            title: "Processing",
            text: "Processing Data",
          });
          const obj = {
            _id: this.id,
            _rev: this.rev,
            a: this.amount,
            b: this.desc,
            c: this.et,
            d: this.ecet.length > 0 ? this.etc.b : "N/A",
            e: this.exc,
            f: this.$session.get("user"),
            g: Date.now(),
            h: this.ef,
            y: Date.now(),
            z: 7,
          };

          if (this.id !== null && this.rev !== null) {
            this.$store
              .dispatch("expenses/updateExpense", obj)
              .then((r) => {
                this.$vs.notify({
                  color: "success",
                  title: "Success",
                  text: r,
                });
                this.$emit("closeSidebar");
                this.initValues();
              })
              .catch((err) => {
                console.error(err);
                this.$vs.notify({
                  color: "danger",
                  title: "Error",
                  text: err,
                });
              });
          } else {
            delete obj._id;
            delete obj._rev;
            this.$store
              .dispatch("expenses/addExpense", obj)
              .then((r) => {
                this.$vs.notify({
                  color: "success",
                  title: "Success",
                  text: r,
                });
                this.$emit("closeSidebar");
                this.initValues();
              })
              .catch((err) => {
                console.error(err);
                this.$vs.notify({
                  color: "danger",
                  title: "Error",
                  text: err,
                });
              });
          }
        }
      });
    },
  },
  components: {
    VuePerfectScrollbar,
    "v-select": vSelect,
  },
  mounted() {
    this.isMounted = true;
  },
};
</script>

<style lang="scss" scoped>
.add-new-data-sidebar {
  ::v-deep .vs-sidebar--background {
    z-index: 52010;
  }

  ::v-deep .vs-sidebar {
    z-index: 52010;
    width: 400px;
    max-width: 90vw;

    .img-upload {
      margin-top: 2rem;

      .con-img-upload {
        padding: 0;
      }

      .con-input-upload {
        width: 100%;
        margin: 0;
      }
    }
  }
}

.scroll-area--data-list-add-new {
  // height: calc(var(--vh, 1vh) * 100 - 4.3rem);
  height: calc(var(--vh, 1vh) * 100 - 16px - 45px - 82px);
}
</style>
